import React from 'react';

import HappyFaceIcon from '../../../components/Icons/HappyFaceIcon';
import NeutralFaceIcon from '../../../components/Icons/NeutralFaceIcon';
import SadFaceIcon from '../../../components/Icons/SadFaceIcon';
import VeryHappyFaceIcon from '../../../components/Icons/VeryHappyFaceIcon';
import VerySadFaceIcon from '../../../components/Icons/VerySadFaceIcon';
import emotionTypes from '../../../consts/loyalty/emotionTypes';
import rumCustomEvents from '../../../services/events/rumCustomEvents';
import {t} from '../../../services/localization/localizationService';
import {twx} from '../../../utils/tailwindUtils';

const CONTENT = [
    {
        icon: VerySadFaceIcon,
        type: emotionTypes.VERY_SAD,
    },
    {
        icon: SadFaceIcon,
        type: emotionTypes.SAD,
        isDefault: true,
    },
    {
        icon: NeutralFaceIcon,
        type: emotionTypes.NEUTRAL,
        isDefault: true,
    },
    {
        icon: HappyFaceIcon,
        type: emotionTypes.HAPPY,
        isDefault: true,
    },
    {
        icon: VeryHappyFaceIcon,
        type: emotionTypes.VERY_HAPPY,
    },
];

const ClubPageEmotions = (props) => {
    const {titleStrCode, activeType, setActiveType, className} = props;

    return (
        <div className={twx('flex w-full items-center justify-between gap-2 py-4', className)}>
            {CONTENT.map(({icon: Icon, type}, index) => {
                const isActive = activeType === type;

                const onIconClick = () => {
                    rumCustomEvents.recordActionSelect({id: type, isSelected: isActive, question: t(titleStrCode)});
                    setActiveType(isActive ? null : type);
                };

                return (
                    <Icon
                        key={index}
                        onClick={onIconClick}
                        className={twx('size-12 shrink-0 cursor-pointer', isActive && '[&>path]:fill-color-tertiary')}
                    />
                );
            })}
        </div>
    );
};

export default ClubPageEmotions;
